/*SYSTEM IMPORTS*/
import React from 'react'
// import c from 'classnames'
// import Logo from 'components/ui/Logo'

import './style'
import './media'

/*Images*/

const ListVideos = props => (
    <div className="list-videos">
        {props.children}
    </div>
)

export default ListVideos